// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__W8rbO","title":"Header_title__1k7Dg","left":"Header_left__x_5mh","clinicName":"Header_clinicName__3OSG6"};